import { BeelineResult } from '../beelineLp/BeelineLanding';

export default function Beeline2Success() {
  return <BeelineResult lpKey="beeline2" outcome="success" variant={2} />;
}
